/**
 * Korzeń wszystkich tras (fala 9, grupa 76; WCAG 3.1.1): `<html lang>` idzie
 * za językiem interfejsu — dawniej był na sztywno „pl”, więc czytnik ekranu
 * czytał angielski interfejs polską wymową. Obejmuje też wejście na `/`
 * (HostEntry) i stronę 404.
 */
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router'

export function RootLayout() {
  const { i18n } = useTranslation()
  const lng = i18n.resolvedLanguage ?? i18n.language
  useEffect(() => {
    document.documentElement.lang = lng.startsWith('en') ? 'en' : 'pl'
  }, [lng])
  return <Outlet />
}
